import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wz-form-group-part-item-title',
  templateUrl: './form-group-part-item-title.component.html',
  styleUrls: ['./form-group-part-item-title.component.scss'],
  standalone: false,
})
export class FormGroupPartItemTitleComponent implements OnInit {
  ngOnInit(): void {}
}
